import React from 'react';
import { Typography, Box, Paper } from '@mui/material';
import AssetSearch from '../components/search/AssetSearch';

const SearchAssetsPage: React.FC = () => {
  const handleSearch = (query: string) => {
    console.log('Search query:', query);
    // Search is handled directly in the AssetSearch component
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'background.default',
      }}
    >
      <Paper
        elevation={2}
        sx={{
          flex: 1,
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', p: 3 }}>
          <Typography variant="h5" gutterBottom>
            Browse Assets
          </Typography>

          <AssetSearch
            onSearch={handleSearch}
            initialParams={{
              // Default to sorting by most recent
              sort: 'createdAt',
              order: 'desc',
              // Limit to 10 most recent assets by default
              limit: 10,
            }}
          />
        </Box>
      </Paper>
    </Box>
  );
};

export default SearchAssetsPage;
